import Container from "react-bootstrap/Container";

const NotAllowed = () => (
  <Container className="h-100 d-flex justify-content-center align-items-center text-danger">
    <h1>You are not allowed to view this site!</h1>
  </Container>
);

export default NotAllowed;
